import template from './topbar.html';
import { NavigationActions } from 'core/services/navigation';
import { LoginActions } from 'core/services/login';
import { rest } from 'core/api';
import { fullscreen, logoutInMap, logout as LOGOUT} from 'core/util';
import config from 'config.json';

export let TopbarComponent = {
  templateUrl: template,
  selector: 'topbar',
  bindings: {

  },
  controller: TopbarCtrl,
  controllerAs: 'vm'
};

TopbarCtrl.$inject = ['$ngRedux', '$window', 'localStorageService', '$timeout'];
let actions = Object.assign({}, NavigationActions);
actions = Object.assign(actions, LoginActions);

function TopbarCtrl($ngRedux, $window, localStorageService, $timeout) {
  Object.assign(this, { $ngRedux, $window });
  this.mapStateToThis = mapStateToThis.bind(this);
  this.toggleUserBar = toggleUserBar.bind(this);
  this.editProfile = editProfile.bind(this);
  this.logout = logout.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, actions)(this);

  this.fullscreen = () => { $timeout(() => fullscreen()); };

  this.$onDestroy = () => {
    unsubscribe();
  };

  this.$onInit = () => {
    this.navigationInit();
    this.$ngRedux.dispatch(rest.actions.currentUser());
  };
  this.publicURL = config.publicURL;



  function mapStateToThis(state) {

    if (state.currentUser) {
      if (state.currentUser.data.code && state.currentUser.data.code === 422) {
        logoutInMap(localStorageService);
      }
      this.user = state.currentUser.data;
    }

    if (state.login.accessToken && state.login.accessToken.code === 401) {
      logoutInMap(localStorageService);
    }

    return { navigation: state.navigation, login: state.login };
  }

  function toggleUserBar() {
    if (this.navigation.userbar.opened) {
      this.closeUserBar();
    } else {
      this.openUserBar();
    }
  }

  function editProfile() {
    // TODO
  }


  function logout() {
    LOGOUT(localStorageService, $window);
  }

}


// WEBPACK FOOTER //
// ./src/components/topbar/topbar.component.js